module.exports = __webpack_public_path__ + "img/logo_urba_trasp.8e4f6d02.png";